app.service('subscriptionMpcBlikPayment', function (loading, modal) {

	let isTransactionsStatusChecking, confirmationAwaitTimeout, statusTimeout;
	const confirmationAwaitTimer = 2; // czas całkowitego oczekiwania na COMPLETED w minutach
	const statusCheckingInterval = 2; // czas ponownego odpytania w sekundach

	function clearAllTimeouts(){
		isTransactionsStatusChecking = false;
		clearTimeout(confirmationAwaitTimeout);
		clearTimeout(statusTimeout);
	}
	function initMpcBlikTransaction(data) {
		clearAllTimeouts();
		openBlikConfirmationModal(); // otwarcie modala z informacja o wymaganym potwierdzeniu

		if (!isTransactionsStatusChecking) {
			isTransactionsStatusChecking = true;
			processMpcBlikStatusVeryfication(data); // rozpoczęcie odpytywania
			confirmationAwaitTimeout = setTimeout(function(){ // brak potwierdzenia w czasie standardowej "żywotności" kodu Blik 
				clearTimeout(statusTimeout);
				modal.alert('Transakcja nie została potwierdzona przez operatora płatności. Prosimy o sprawdzenie statusu płatności w koncie klienta.', function(){
					loading.reload();
				});
			}, confirmationAwaitTimer*60*1000);
		}

	}
	function processMpcBlikStatusVeryfication(data) {
		if (isTransactionsStatusChecking) {
			$.ajax({
				url: '/customer-subscription-payment-status.ltr',
				data: {
					recurringPaymentId: data.recurringPaymentId
				},
				success: function (json) {
					if(json.status == 'COMPLETED') { //potwierdzony status platnosci
						modal.close();
						clearAllTimeouts();
						openBlikSuccessModal();
					} else {
						statusTimeout = setTimeout(function(){
							processMpcBlikStatusVeryfication(data);
						}, statusCheckingInterval*1000);
					}
				},
				error: function () {
					modal.alert('Błąd pobierania danych podczas sprawdzania statusu transakcji');
				}
			});
		}
	}
	function openBlikConfirmationModal() {
		modal.open('EPayment-blik-confirm',{
			closeOnEscape: false,
			closeOnOutsideClick: false,
		});
	}
	function openBlikSuccessModal() {
		const $modalBlikSuccess = modal.open('EPayment-blik-success',{
			closeOnEscape: false,
			closeOnOutsideClick: false,
		});
		modal.callbackClose($modalBlikSuccess, function(){
			loading.reload();
		});
	}

	return {
		init:initMpcBlikTransaction
	};
});